<companyid-content-wrapper classNames="flex-col py-80px gap-y-40px w-full tab:px-5 mob:px-5 z-10">
    <companyid-title-and-subtitle
        i18n-title="@@title-connect-with-our-team"
        i18n-subtitle="@@subtitle-complete-this-form"
        title="Connect with our team"
        subtitle="Complete this form and we’ll respond within one business day."
    />
    <div class="flex gap-40px w-full tab:flex-col mob:flex-col gap-y-40px">
        <form [formGroup]="form" class="flex flex-col w-full gap-y-40px desk:max-w-[490px]">
            <div class="flex flex-col gap-y-15px">
                <div class="flex gap-15px mob:flex-col mob:gap-y-15px">
                    <companyid-input
                        i18n-label="@@label-name"
                        i18n-placeholder="@@placeholder-name"
                        label="Name"
                        required
                        class="w-full"
                        placeholder="Your Name"
                        formControlName="name"
                    />

                    <companyid-input
                        i18n-label="@@label-surname"
                        i18n-placeholder="@@placeholder-surname"
                        label="Surname"
                        class="w-full"
                        formControlName="surname"
                        placeholder="Your Surname"
                    />
                </div>

                <companyid-input
                    i18n-label="@@label-email"
                    i18n-placeholder="@@placeholder-email"
                    label="Email"
                    required
                    placeholder="Your Work Email"
                    formControlName="email"
                />
                <div class="flex gap-15px">
                    <companyid-countries-dropdown formControlName="code" />
                    <companyid-input
                        i18n-label="@@label-phone"
                        [mask]="mask()"
                        label="Phone"
                        class="w-full"
                        required
                        [placeholder]="mask()"
                        formControlName="phone"
                    />
                </div>

                <companyid-input
                    i18n-label="@@label-short-message"
                    i18n-placeholder="@@placeholder-short-message"
                    required
                    label="Short message"
                    formControlName="shortMessage"
                    placeholder="Write your message"
                    textarea
                />
            </div>
            <button i18n="@@button-contact-us" class="button-primary w-full" (click)="sendEmail()">Contact Us</button>
        </form>
        <div
            class="flex flex-col rounded-22px border border-solid border-gray-3 p-35px bg-white/80 backdrop-blur-[42px] gap-y-40px w-full z-10 h-fit"
        >
            <companyid-locales class="gap-y-60px" showSales />
            <companyid-social-media isDark />
        </div>
    </div>
    <span class="text-small-regular text-primary-text-color" i18n
        >By submitting this form, I agree to the
        <span class="underline cursor-pointer">СompanyID Privacy Policy</span></span
    >
    <img
        [ngSrc]="'blue-vectors' | asset: 'contact-us/connect-with-our-team' : 'webp'"
        fill
        alt="blue-vectors"
        class="absolute bottom-0 right-0 object-none tab:hidden mob:hidden h-[940px] max-h-[940px] w-screen"
    />
</companyid-content-wrapper>
